import t from '@jetshop/intl';
import React from 'react';
import {
  DropdownMenuButton,
  DropdownMenuItem,
  DropdownMenuItems,
} from '@jetshop/ui/DropdownMenu';
import { FilterDropdownMenu } from './FilterDropdownMenu';
import { ListSortingItem } from './ListSortingItem';
import { useSortOrder } from '@jetshop/core/hooks/Filters/useSortOrder';
import SortingIcon from '../../ui/icons/SortingIcon';

const ListSorting = ({ sortOrders }) => {
  const { mappedSortOrder, changeSortOrder, sortOrder, direction } =
    useSortOrder({ sortOrders });
  const selectedValue = mappedSortOrder.find((item) => {
    return item.direction === direction && item.value === sortOrder;
  });
  return (
    <FilterDropdownMenu>
      <DropdownMenuButton>
        <div className="icon-holder">
          <SortingIcon />
        </div>
        <span className="sorting-name title">
          {selectedValue ? selectedValue.text : t('Sort By')}
        </span>
      </DropdownMenuButton>
      <DropdownMenuItems className="right">
        {mappedSortOrder.map((item, index) => {
          return (
            <DropdownMenuItem
              key={index}
              onSelect={({ setIsOpen }) => {
                if (item.direction === direction && item.value === sortOrder)
                  changeSortOrder(null, null);
                else changeSortOrder(item.value, item.direction);
                setIsOpen(false);
              }}
            >
              <ListSortingItem
                selected={
                  item.direction === direction && item.value === sortOrder
                }
                item={item}
              />
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuItems>
    </FilterDropdownMenu>
  );
};
export default ListSorting;
